var host = '//act-api.bos.ycgame.com';

var _crossAjaxDefer;
var getCrossAjax = function () {
    if (!_crossAjaxDefer) {
        _crossAjaxDefer = $.Deferred();
        require.ensure(['@moln/cross-domain-ajax'], function () {
            var CrossAjax = require('@moln/cross-domain-ajax');
            var cajax = new CrossAjax('//act-api.bos.ycgame.com/cross-proxy.html');
            cajax.ready(function () {
                _crossAjaxDefer.resolve(cajax);
            });
        });
    }

    return _crossAjaxDefer;
};


var corsAjax = function (method, url, data) {

    var defer, self = this;
    if ($.support.cors) {
        defer = $.ajax({
            type: method,
            url: url,
            data: data,
            xhrFields: {
                withCredentials: true
            }
        });
    } else {
        defer = getCrossAjax().then(function (cajax) {
            var defer = $.Deferred();
            window.cajax = cajax;
            cajax.ajax({
                type: method,
                url: url,
                data: data,
                success: function (data, req) {
                    defer.resolve(data, req);
                },
                error: function (req) {
                    defer.reject(req);
                }
            });

            return defer;
        });
    }

    defer.fail(function (response) {
        if (response.status >= 500) {
            alert('系统错误，请稍后在试！错误码：' + response.status);
            return ;
        }

        if (self._failAlert) {
            if (response.status >= 400) {
                var result = response.responseJSON;
                var msg = (result && result.detail) || '未知错误';
                if (!result.code) {
                    alert('错误(' + response.status + '): ' + msg);
                }
            } else {
                alert('未知错误: ' + response.status);
            }
        }
    });

    return defer.then(function () {
        return defer;
    }, function (response) {
        return $.Deferred(function (def) {
            def.reject(response, response.responseJSON || {})
        });
    });
};

var Rest = function (url) {
    this.url = host + url;
    this._failAlert = true;
};

Rest.prototype.setFailAlert = function (failAlert) {
    this._failAlert = failAlert;
};

Rest.prototype.get = function (query) {
    return corsAjax.call(this, 'GET', this.url, query);
};

Rest.prototype.post = function (params) {
    return corsAjax.call(this, 'POST', this.url, params);
};

Rest.prototype.del = function () {
    return corsAjax.call(this, 'DELETE', this.url);
};

Rest.prototype.put = function (params) {
    return corsAjax.call(this, 'PUT', this.url, params);
};

Rest.prototype.patch = function (params) {
    return corsAjax.call(this, 'PATCH', this.url, params);
};

Rest.prototype.head = function () {
    return corsAjax.call(this, 'HEAD', this.url);
};

module.exports = Rest;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@ycgame/fetch-act-api/src/rest.js
// module id = 37
// module chunks = 1